import { Link, OfferCardData } from "../offers/offer-card-data.model";
import {Module} from "../../model/ModuleModel";
import { UserLandingV2Item } from "../user-landings-v2/user-landings-v2-models";

export interface WizumenModuleModel extends Module<WizumenModuleData>{
  unique_id: string;
}

export interface WizumenModuleData {
  title: string;
  subtitle?: string;
  pig_text: string;
  status: EmpireStateCode;
  items: WizumenModel[];
  default_opened: boolean;
}

export interface WizumenModel {
    trip_id: string;
    time_to_trip_message?: string;
    from_date: string;
    to_date: string;
    trip_last_week: boolean;
    from?: string;
    to: string;
    pig_discount: number;
    bought: WizumenProduct[];
    additionals: WizumenAdditional[];
    to_city_code: string;
    assistance_offers?: SwipeToBuy[];
    booking_info: BookingInfo;
    wizumen_guide_href: string;
    wizumen_guide: WizumenGuide;
    products: ProductAmount[];
    button_text: string;
    // Deprecado
    modal_texts?: WizumenModalText;
    xsell_banner?: XSellBanner;
    list_items?: WizumenProductV2[];
    wizumen_v2?: boolean;
    destination_media_key: string;
    trip_status: string;
    link?: Link;
    wizumen_trip_planner?: WizumenTripPlanner;
    travel_assistance?: TravelAssistance
}

export interface WizumenTripPlanner {
  title: string;
  subtitle?: string;
  trip_planner?: UserLandingV2Item
  link?: Link;
}

export interface TravelAssistance {
  title: string;
  link: Link;
}

export interface LoyaltyInfo {
  title: string;
  description: string;
}

export interface WizumenProduct {
    type: TripProductType;
    name?: string;
    passengers?: number;
    rooms?: number;
    from_date: string;
    from_time?: string;
    formatted_from_date: string;
    to_date: string;
    formatted_to_date: string;
    from?: string;
    to?: string;
    booking_info: BookingInfo;
    icon: string;
    product?: JeanProduct;
}

export interface WizumenProductV2 {
  type: TripProductType;
  icon: string;
  name?: string;
  label?: string;
  description: string[];
  order_type: OrderType;
  product_status: EmpireStateCode;
}

export interface XSellBanner {
    title?: string;
    text?: string;
    coupon_code?: string;
    coupon_copied_text?: string;
    links: Link[];
    offers: OfferCardData[];
    type: TripProductType;
    background_color?: string;
    coupon_icon?: string;
}

export interface WizumenAdditional {
    type: TripProductType;
    href?: string;
    icon: string;
    title?: string;
    text?: string;
    link_text?: string;
}

export interface SwipeToBuy {
    product: TripProductType;
    id: string;
    code: string;
    title: string;
    description: string;
    description_items: string[];
    price: SwipeToBuyPrice;
    price_message: string;
    buy_button_message: string;
    remember_later_message: string;
    days_before_trip: number;
    loyalty: SwipeToBuyLoyalty;
    upa_data: {[key: string] : any};
    button_url?: string;
    destination_media_key?: string;
    coupon_code?: string;
    coupon_copied_text?: string;
    background_color?: string;
    days_after_purchase?: number;
}

export interface SwipeToBuyPrice {
    currency: string;
    symbol: string;
    amount: string;
    regular_amount: string;
    saving: string;
    discount: BigInteger;
    description_text: string;
    legal_text: string;
    installments_text: string;
    ribbon_type: string;
    unformated_price: number;
}

interface SwipeToBuyLoyalty {
    points: {
        accumulation: number;
        redemption: number;
        aquisition: number;
    };
    redemption: {
        description: string;
        summary: {
            currency: string;
            to_pay: string;
            saved: string;
        }
    };
}

interface BookingInfo {
    status: EmpireStateCode;
    description: string;
    confirmed: boolean;
    open: boolean;
    status_priority: number;
}

export interface ProductAmount {
    type: TripProductType;
    amount: number;
    product_status: EmpireStateCode;
    icon: string;
}

export enum OrderType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY"
}

export interface IncentiveXSell {
  tripId: string;
  type: TripProductType;
}

export interface IncentiveXSellStorage {
  tripId: string;
  hideIncentives: TripProductType[];
}

export enum TripProductType {
    FLIGHT = "FLIGHT",
    HOTEL = "HOTEL",
    CRUISE = "CRUISE",
    CAR = "CAR",
    TICKET = "TICKET",
    DISNEY = "DISNEY",
    TOUR = "TOUR",
    TRANSFER = "TRANSFER",
    VACATION_RENTAL = "VACATION_RENTAL",
    TRIPS = "TRIPS",
    INSURANCE = "INSURANCE",
    SAFEGUARD = "SAFEGUARD",
    BUS = "BUS",
    XSELL_HOTEL = "XSELL_HOTEL",
    XSELL_TICKET ="XSELL_TICKET",
    XSELL_INSURANCE = "XSELL_INSURANCE",
    XSELL_FINAL ="XSELL_FINAL",
    XSELL_MALBEC = "XSELL_MALBEC",
}

export enum EmpireStateCode {
    CONFIRMED = "CONFIRMED",
    OPEN = "OPEN",
    IN_PROCESS = "IN_PROCESS",
    PENDING = "PENDING",
    AFFECTED = "AFFECTED",
    CANCELLED = "CANCELLED",
    PROVIDER_CONTROL = "PROVIDER_CONTROL",
}

interface WizumenStatus {
    name: EmpireStateCode;
    priority: number;
    layoutInfo: string;
    driverInfo: string;
}
export class WizumenStatusResolver {
    static wizumenStatusMap: { [key: string] : WizumenStatus } =
    {
        ["CONFIRMED"]: { name: EmpireStateCode.CONFIRMED, priority: 1, layoutInfo: "-success", driverInfo: "-success" },
        ["OPEN"]: { name: EmpireStateCode.OPEN, priority: 2, layoutInfo: "-warning", driverInfo: "-information" },
        ["IN_PROCESS"]: { name: EmpireStateCode.IN_PROCESS, priority: 3, layoutInfo: "-information", driverInfo: "-information" },
        ["PENDING"]: { name: EmpireStateCode.PENDING, priority: 4, layoutInfo: "-information", driverInfo: "-warning" },
        ["AFFECTED"]: { name: EmpireStateCode.AFFECTED, priority: 5, layoutInfo: "-information", driverInfo: "-warning" },
        ["CANCELLED"]: { name: EmpireStateCode.CANCELLED, priority: 0, layoutInfo: "", driverInfo: "" },
        ["PROVIDER_CONTROL"]: { name: EmpireStateCode.PROVIDER_CONTROL, priority: 0, layoutInfo: "", driverInfo: "" },
    }

    static getLayoutInfo(name: EmpireStateCode) {
        return WizumenStatusResolver.wizumenStatusMap[name].layoutInfo;
    }

    static getDriverInfo(name: EmpireStateCode) {
        return WizumenStatusResolver.wizumenStatusMap[name].driverInfo;
    }

    static getPriority(name: EmpireStateCode) {
        return WizumenStatusResolver.wizumenStatusMap[name].priority;
    }
}

export interface WizumenModalText {
    title: string;
    pig_title: string;
    pig_text: string;
    bought_products_title: string;
    my_travels_link_text: string;
}

export interface WizumenGuide {
    title: string;
    text: string;
    link_text: string;
}

interface JeanProduct {
  product_type: TripProductType;
  passengers: number;
  name: string;
  from: string;
  to: string;
}

export interface JeanFlight extends JeanProduct {
  to_city_code: string;
  round_trip: boolean;
}
